import { FieldValues, UseFormSetValue } from 'react-hook-form';
import { store } from 'store/store';
import { parseDanishAmount } from '../utilities/format';
import { DEPEND_CONDITION_RULES, evaluateDependency } from './DependencyService';

const SUBMIT_ERROR_ID = 'SUBMIT_INSURANCE_ERROR';

// TODO(CD-02): Reconcile visibility/validation leaf semantics before sharing comparisons; do not silently replace either.
const isValid = (rule: ContentDependencyLeaf, actualValue: string): boolean => {
	if (rule.dependCondition !== DEPEND_CONDITION_RULES.EMPTY) {
		if (actualValue === undefined || actualValue === null) {
			return false;
		}
		if (rule.dependValue === undefined || rule.dependValue === null) {
			return true;
		}
	}
	switch (rule.dependCondition) {
		case DEPEND_CONDITION_RULES.EMPTY:
			return !actualValue || actualValue?.trim() === '';
		case DEPEND_CONDITION_RULES.EQUALS:
			return actualValue === rule.dependValue;
		case DEPEND_CONDITION_RULES.NOT_EQUALS:
			return actualValue !== rule.dependValue;
		case DEPEND_CONDITION_RULES.GREATER_THAN:
			return parseDanishAmount(actualValue) > parseDanishAmount(rule.dependValue);
		case DEPEND_CONDITION_RULES.LESS_THAN:
			return parseDanishAmount(actualValue) < parseDanishAmount(rule.dependValue);
		case DEPEND_CONDITION_RULES.GREATER_THAN_OR_EQUAL_TO:
			return parseDanishAmount(actualValue) >= parseDanishAmount(rule.dependValue);
		case DEPEND_CONDITION_RULES.LESS_THAN_OR_EQUAL_TO:
			return parseDanishAmount(actualValue) <= parseDanishAmount(rule.dependValue);
		case DEPEND_CONDITION_RULES.CONTAINS:
			return actualValue.includes(rule.dependValue);
		case DEPEND_CONDITION_RULES.NOT_CONTAINS:
			return !actualValue.includes(rule.dependValue);
		case DEPEND_CONDITION_RULES.NOT_APPLICABLE:
			return !!actualValue;
		case DEPEND_CONDITION_RULES.MATCH_REGULAR_EXPRESSION:
			console.warn(DEPEND_CONDITION_RULES.MATCH_REGULAR_EXPRESSION, 'not implemented');
			return true; // NOT implemented
		default:
			return true;
	}
};

export const validateForm = (setValue: UseFormSetValue<FieldValues>, metaArea: MetaArea): boolean => {
	// clear submit error message
	const rules = metaArea.items[0].content?.validationRules?.items ?? [];
	setValue(SUBMIT_ERROR_ID, getFormErrorValue('NONE'));

	const form = store.getState().calculatorForm;
	let valid = true;
	rules.forEach((rule) => {
		if (!valid) {
			return;
		}
		// TODO(CD-06): Discard failures from OR branches that ultimately match before selecting the reported field.
		let failedFieldId: string | undefined;
		// Share group traversal with visibility, but keep submit validation's leaf comparisons.
		const ruleIsValid = evaluateDependency(rule.content, (leaf) => {
			const fieldId = leaf.dependsOn?.uid;
			const leafIsValid = fieldId ? isValid(leaf, form[fieldId]?.data?.value) : false;
			if (!leafIsValid && !failedFieldId) {
				failedFieldId = fieldId;
			}
			return leafIsValid;
		});
		if (!ruleIsValid) {
			// Empty OR groups have no failing leaf UID, so use the generic configured failure.
			const errorId = failedFieldId ?? 'FAIL';
			setValue(SUBMIT_ERROR_ID, getFormErrorValue(errorId));
			console.error('SUBMIT_ERROR', errorId, getFormErrorValue(errorId));
			valid = false;
		}
	});

	return valid;
};

export const setSubmitOpportunityError = (setValue: UseFormSetValue<FieldValues>) => {
	setValue(SUBMIT_ERROR_ID, getFormErrorValue('FAIL'));
	console.error('SUBMIT_ERROR', 'FAIL', getFormErrorValue('FAIL'));
};

const getFormErrorValue = (id: string) => {
	return {
		id: SUBMIT_ERROR_ID,
		value: id,
		type: 'SUBMIT_INSURANCE',
	};
};
